import React from 'react';
import { listContainerStyle, sectionHeaderStyle } from './styles';

interface PlatformListProps {
  platforms: any[];
}

export const PlatformList: React.FC<PlatformListProps> = ({ platforms }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Platforms ({platforms.length})</div>
      <div style={listContainerStyle}>
        {platforms.length === 0 ? (
          <div style={{ fontSize: '11px', color: '#666', textAlign: 'center' }}>No platforms</div>
        ) : (
          platforms.slice(0, 50).map((p, i) => (
            <div key={p.id || i} style={{
              fontSize: '10px',
              color: '#aaa',
              padding: '4px 0',
              borderBottom: '1px solid rgba(255,255,255,0.05)',
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <div>
                <span style={{ color: '#fff' }}>{p.id || `plat_${i}`}</span>
                <span style={{ marginLeft: '8px', color: '#666' }}>({p.type})</span>
              </div>
              <span style={{ fontFamily: 'monospace' }}>{p.width}x{p.height} @ {p.x},{p.y}</span>
            </div>
          ))
        )}
        {platforms.length > 50 && (
          <div style={{ fontSize: '10px', color: '#666', textAlign: 'center', marginTop: '5px' }}>
            ... and {platforms.length - 50} more
          </div>
        )}
      </div>
    </>
  );
};
